import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingController {
  private _visible = false;
  private _message = '';

  constructor() {}

  get visible() {
    return this._visible;
  }

  get message() {
    return this._message;
  }

  /**
   * Display the root loading dialogue
   * @param param0
   */
  async present({ message = '' }: { message?: string } = {}): Promise<void> {
    this._visible = true;
    this._message = message;
    await this.waitForAnimation();
    return;
  }

  async dismiss(): Promise<void> {
    this._visible = false;
    this._message = '';
    await this.waitForAnimation();
    return;
  }

  /**
   * Replicates animation duration > 150ms cubic-bezier(0, 0, 0.2, 1)
   * @returns
   */
  private waitForAnimation(): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, 150));
  }
}
